/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ credits: NonNullable<unknown>, price: NonNullable<unknown>, from: NonNullable<unknown> }} Directory_Ai_Tools_Studio_Price_LineInputs */

const en_directory_ai_tools_studio_price_line = /** @type {(inputs: Directory_Ai_Tools_Studio_Price_LineInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.credits} credits ≈ ${i?.price} · packs from ${i?.from}, no subscription`)
};

const zh_directory_ai_tools_studio_price_line = /** @type {(inputs: Directory_Ai_Tools_Studio_Price_LineInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.credits} 积分 ≈ ${i?.price} · 积分包 ${i?.from} 起，无需订阅`)
};

/**
* | output |
* | --- |
* | "{credits} credits ≈ {price} · packs from {from}, no subscription" |
*
* @param {Directory_Ai_Tools_Studio_Price_LineInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_ai_tools_studio_price_line = /** @type {((inputs: Directory_Ai_Tools_Studio_Price_LineInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Ai_Tools_Studio_Price_LineInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_ai_tools_studio_price_line(inputs)
	return zh_directory_ai_tools_studio_price_line(inputs)
});
export { directory_ai_tools_studio_price_line as "directory.ai_tools.studio.price_line" }